import React, {useEffect, useState} from "react";
import {ActionButton} from "../components/buttons";
import DynamicTable from "../components/DynamicTable";
import {columns} from "../helpers/tableData";
import {CommonModal} from "../dialogs";
import {useDispatch} from "react-redux";
import {usePagination} from "../hooks";
import {$crud} from "../services/CrudFactory";
import {ConfirmationModal} from "../dialogs/ConfirmationModal";
import Typography from "@mui/material/Typography";

export const Degrees = () =>{
    const dispatch = useDispatch();
    const [status, setStatus] = useState(null);
    const [idToRemove, setIdToRemove] = useState(null);
    const [degrees, setDegrees] = useState([]);
    const {limit, setLimit, page, setPage, total, setTotal} = usePagination();

    const statusChange=async (id) => {
        try {
            dispatch({
                type: "LOADER",
                loader: true
            });
            const {type, message} = await $crud.post("create/web/status/statuses", {
                id
            });
            retrieveDegrees().then(res => {
                setDegrees(res.degrees);
            });
            dispatch({
                type: "SNACKBAR",
                snackBar: {type, message}
            });
        } catch (e) {
            dispatch({
                type: "SNACKBAR",
                snackBar: {type: "error", message: e.message}
            });
        } finally {
            dispatch({
                type: "LOADER",
                loader: false
            });
        }
    };

    const retrieveDegrees=async () => {
        try {
            dispatch({
                type: "LOADER",
                loader: true
            });
            const {data } = await $crud.retrieve("web/degree-and-diplomas",{limit,page});
            return data;
        } catch (e) {
            dispatch({
                type: "SNACKBAR",
                snackBar: {type: "error", message: e.message}
            });
        } finally {
            dispatch({
                type: "LOADER",
                loader: false
            });
        }
    };
    const remove = async(id)=>{
        try {
            dispatch({
                type: "LOADER",
                loader: true
            });
            const {type, message } = await $crud.post("delete/web/degree-and-diploma",{id});
            dispatch({
                type: "SNACKBAR",
                snackBar: {type, message}
            });
            retrieveDegrees().then(res=>setDegrees(res.degreeAndDiplomas));
            setIdToRemove(null);
        } catch (e) {
            dispatch({
                type: "SNACKBAR",
                snackBar: {type: "error", message: e.message}
            });
        } finally {
            dispatch({
                type: "LOADER",
                loader: false
            });
        }
    };
    useEffect(()=>{
        retrieveDegrees().then(res=> {
            setDegrees(res.degreeAndDiplomas);
            setTotal(res.total);
        });
    },[limit,page]);
    return (
        <>
            <div>
                <div className='row w-100 g-2'>
                    <div className='mb-3 d-flex'>
                        <ActionButton onClick={() => setStatus({})} buttonName="Add Degree"/>
                    </div>
                </div>
            </div>
            <DynamicTable
                rows={degrees}
                columns={columns?.colleges}
                style={{maxHeight: "calc(100vh - 102px)"}}
                total={total}
                onRowClick={() => {
                }}
                onStatusChange={(id) => {
                    statusChange(id);
                }}
                onEdit={(value) => {
                    setStatus(value);
                }}
                onDelete={(id)=>setIdToRemove(id)}
                paginationProps={{
                    limit: limit,
                    page: page,
                    onChangeLimit: (limit) => setLimit(limit),
                    onChangePage: (page) => setPage(page),
                }}
            />
            <CommonModal
                onSave={() => {
                    retrieveDegrees().then(res=>setDegrees(res.degreeAndDiplomas));
                }}
                title="Degree"
                apiUrl="web/degree-and-diploma"
                data={status}
                onClose={() => setStatus(null)}
                open={!!status}
            />
            <ConfirmationModal
                open={!!idToRemove}
                title="Remove Degree"
                content={
                    <>
                        <Typography variant="subtitle1" >Removing Degree may lead to
                            Data Insufficiency In Lead | Make Sure to assign
                            Another Degree Ids To These  Leads.</Typography>
                        <Typography variant="subtitle2" > Press &apos;Yes&apos; To Remove
                            anyway.</Typography>
                    </>
                }
                onClose={() => {
                    setIdToRemove(null);
                }}
                onOk={() => remove(idToRemove)}
            />
        </>
    );
};